import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tw-text-sm" }

import { computed, ref } from "vue"
  import { QSelect } from "quasar"

  import { DrivingLicenceOptions } from "src/const/select-options"

  
export default /*@__PURE__*/_defineComponent({
  __name: 'DrivingLicenceSelect',
  props: {
    modelValue: {
      type: Number,
      default: null,
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  emits: [
    'update:modelValue'
  ],
  setup(__props, { expose: __expose, emit: __emit }) {

  const props = __props

  const value = computed<number | null>({
    get() {
      if (props.modelValue) {
        return props.modelValue
      }
      else {
        return null
      }
    },
    set(value: number | null) {
      emit('update:modelValue', value)
    }
  })

  const emit = __emit

  const drivingLicenceSelectRef = ref<QSelect | null>(null);
  function validate(){
    return drivingLicenceSelectRef.value!.validate();
  }
  __expose({ validate })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _renderSlot(_ctx.$slots, "default"),
    _createVNode(_unref(QSelect), {
      modelValue: value.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
      modelModifiers: { number: true },
      options: _unref(DrivingLicenceOptions),
      ref_key: "drivingLicenceSelectRef",
      ref: drivingLicenceSelectRef,
      rules: [val => (__props.required === true && !!val) || !__props.required || 'Required'],
      "emit-value": "",
      class: _normalizeClass(!drivingLicenceSelectRef.value?.hasError ? 'tw-shadow-sm' : ''),
      "popup-content-class": "tw-text-sm limit-dd-height",
      "dropdown-icon": "mdi-chevron-down",
      label: value.value ? undefined : 'Select a licence...',
      "map-options": "",
      "data-cy": "drivingLicenceSelect",
      outlined: "",
      dense: "",
      "data-clarity-unmask": "true"
    }, {
      selected: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(DrivingLicenceOptions).find(t => t.value === value.value)?.label), 1)
      ]),
      _: 1
    }, 8, ["modelValue", "options", "rules", "class", "label"])
  ], 64))
}
}

})